<template>
	<figure :class="['figure', { first }]">
		<img :src="block.url">
	</figure>
</template>

<script>

	export default {
		props: ['block', 'first']
	}

</script>

<style lang="scss" scoped>
	@import "media";
	.figure {
		@include media(large) {
			margin-left:2.5vw; margin-right:2.5vw;
			&.first {
				margin-top:2.5vw;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/BlogBlockTypes/Image.vue